import { SegurosProvider } from "../../context/segurosContext";
import { Outlet } from "react-router-dom";

const SegurosContextLayout = () => {
    return (
        <SegurosProvider>
            <Outlet />
        </SegurosProvider>
    );
};

export default SegurosContextLayout;
